"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMuxVideoThumbnailUrl = getMuxVideoThumbnailUrl;
function getMuxVideoThumbnailUrl({ muxPublicPlaybackId, width, }) {
    return `https://image.mux.com/${muxPublicPlaybackId}/thumbnail.jpg?width=${width}&fit_mode=preserve`;
}
